









import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import type { ProductForProductPageType } from '~/utils/types/solepro/Product';
import ProductIncipitInfo from './ProductIncipitInfo.vue';

import ProductIncipitInfoBook from './ProductIncipitInfoBook.vue';

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        },
        isBook: {
            type: Boolean
        }
    },
    components: {

        ProductIncipitInfo,
        ProductIncipitInfoBook,
    },
    setup(props) {
        const galleryImages = (props?.product?.mediaGallery ?? []).filter(el => !el.disabled).sort((a, b) => a.position - b.position)
        const isSingleVideo = galleryImages.length == 1 && !!galleryImages[0].video_content;
        const GalleryComponent = isSingleVideo
            ? () => import('~/components/solepro/ProductPage/ProductSingleVideo.vue')
            : () => import('~/components/solepro/ProductPage/ProductGalleryIncipit.vue')
        const componentProps = isSingleVideo ? {product: props.product} : {product: props.product, isBook:props.isBook}

        return {
            hasGallery: galleryImages.length > 0,
            GalleryComponent,
            componentProps
        }
    }
})
